import React from 'react'
import styled from 'styled-components'
import Link from 'atoms/Link'
import { ProfileConsumer } from 'contexts/profile-context'
import { DropdownConsumer } from 'atoms/Dropdown'
import PropTypes from 'prop-types'
import GiftTop from '../GiftTop'
import GiftBottom from '../GiftBottom'

const Wrapper = styled.div`
    color: black;
    margin: 16px;
    
    .shgn-draft-promo {
        display: none;
    }

    [data-optimize-variant="draft"] & .shgn-salary-cap-promo {
        display: none;
    }

    [data-optimize-variant="draft"] & .shgn-draft-promo {
        display: flex;
    }
`

const CloseButton = styled.div`
    background-color: rgba(85, 188, 189, 1);
    border: 2px solid rgba(85, 188, 189, 1);
    border-radius: 6px;
    padding: 12px 32px;
    margin-top: 8px;
    color: #FFF;
    line-height: 16px;
    text-align: center;
    text-decoration: none;
`

function DropdownBody (props) {
  const { bonus } = props

  if (bonus === null || undefined) {
    return null
  }

  const hasLinkToContest = !!bonus.destinationUri

  const onContestLink = hasLinkToContest && (bonus.destinationUri === window.location.href)

  return (
    <ProfileConsumer>
      {profile => {
        return (
          <DropdownConsumer>
            { dropdown => {
              return (
                <Wrapper>
                  <GiftTop
                    bonusAmount={bonus.bonusAmount}
                    onUsText="On Us."
                  />
                  <GiftBottom linkUri={bonus.destinationUri} hasLinkToContest={hasLinkToContest} onContestLink={onContestLink}>
                    You&apos;ve got a bonus!
                    <br />
                    Feel free to use these bonus funds for a game on Fanball this week.
                    <br />
                    Bonus funds do expire, so don&apos;t delay!
                    <br />
                    { (!hasLinkToContest || onContestLink) &&
                      <CloseButton onClick={dropdown.close}>Got It</CloseButton>
                    }
                  </GiftBottom>
                </Wrapper>
              )
            }
            }
          </DropdownConsumer>
        )
      }}
    </ProfileConsumer>
  )
}

DropdownBody.propTypes = {
  bonus: PropTypes.object.isRequired,
}

export default DropdownBody



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/DropdownBody/DropdownBody.js